import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { HttpParams } from '@angular/common/http';

export enum LoginMode {
  Login = 0,
  PasswordReset = 1,
  Signup = 2,
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  public username: string;

  public password: string;

  public invalidLogin: string = null;

  public oobCode: string;

  public querySub: Subscription;

  public user: string;

  public token: string;

  public mode = LoginMode.Login;

  public modes = LoginMode;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  public ngOnInit(): void {
    this.querySub = this.route
      .queryParams
      .subscribe(() => {
        this.mode = LoginMode.Login;
        this.oobCode = this.token = this.getParamValue('oobCode');
        if (this.oobCode) {
          this.mode = LoginMode.PasswordReset;
        }

        // Do we have a new user signup
        // Check first if we have a signup code.
        // Note that if you reached this page, you probably do not have any session
        // this.user = this.route.snapshot.queryParamMap.get('user');
        this.user = this.getParamUser();
        this.token = this.getParamValue('token');

        if (this.user && this.token) {
          this.mode = LoginMode.Signup;
        }
      });
  }

  public ngOnDestroy(): void {
    this.querySub.unsubscribe();
  }

  public login(form: NgForm): void {
    if (form.invalid) {
      return;
    }

    this.invalidLogin = null;

    this.authService
      .login(this.username, this.password)
      .toPromise()
      .then(() => this.authService
                        .hasValidSession()
                        .toPromise())
      .then((session) => {
        if (session) {
          this.router.navigate(['/']);
        } else {
          this.showInvalid();
        }
      })
      .catch(() => {
        this.showInvalid();
      });
  }

  private showInvalid(): void {
    this.invalidLogin = 'Invalid username or password';
  }

  private getParamValue(param: string): string {
    /**
     * '&amp;' is the escapeHtml equivalent for '&' this is added because regular '&' does not render properly in the
     * invite email
     */

    const url = this.router.url;
    if (url.includes('&amp;')) {
      const decodeUrl = decodeURIComponent(this.router.url);
      const cleanUrl = decodeUrl
        .split('amp;')
        .join('');
      const params = new HttpParams({fromString: cleanUrl.split('?')[1]});
      return params.get(param);
    }

    return this.route.snapshot.queryParamMap.get(param);
  }

  private getParamUser(): string {
    const decodeUrl = decodeURIComponent(this.router.url);
    const params = new HttpParams({fromString: decodeUrl.split('?')[1]});
    return params.get('user');
  }
}
